import { render, staticRenderFns } from "./AddressShow.vue?vue&type=template&id=3ac058b3&scoped=true&"
import script from "./AddressShow.vue?vue&type=script&lang=js&"
export * from "./AddressShow.vue?vue&type=script&lang=js&"
import style0 from "./AddressShow.vue?vue&type=style&index=0&id=3ac058b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac058b3",
  null
  
)

export default component.exports